import { Component, Input, OnInit } from '@angular/core';
import { LMapService } from 'app/shared/ll/services';
import { FeatureGroup, Layer, Path } from 'leaflet';


@Component({
    selector: 'l-feature-group',
    template: ``,
})
export class LFeatureGroupComponent implements OnInit {

    group: FeatureGroup;

    @Input() name: string;

    @Input() bringToFront = false;

    constructor(protected mapService: LMapService) {
        this.group = new FeatureGroup();
    }

    ngOnInit() {
        this.mapService.addGroup(this.name, this.group);
    }

    addToGroup(feature: Layer) {
        this.group.addLayer(feature);
        if (this.bringToFront) {
            if (typeof (feature as Path).bringToFront === 'function') {
                (feature as Path).bringToFront();
            }
        } else {
            if (typeof (feature as Path).bringToBack === 'function') {
                (feature as Path).bringToBack();
            }
        }
    }
}
